<template>
    <div class="item-slider">
        <Swiper class="item-slider__slider" 
            :class="sliderClass" 
            :options="sliderOptions" 
            ref="slider" 
            :auto-update="true" 
            @ready="sliderReadyHandler" 
            @fromEdge="checkSliderEdgeStatus"
            @toEdge="checkSliderEdgeStatus"
            @reachEnd="sliderReachEndHandler" 
            @reachBeginning="sliderReachBeginningHandler"
            v-on:sliderMove.once="sliderMoveStartHandler"
        >
            <slot />
        </Swiper>
        <div class="item-slider__navigation" v-if="showNavigation">
            <transition name="fade">
                <div class="item-slider__navigation__arrow item-slider__navigation__arrow--prev" v-show="!sliderIsBeginning" @click="prevSliderHandler">
                    <SmrTooltip :content="tooltips.left ? tooltips.left.content : ''" :position="tooltips.left ? tooltips.left.position : ''" :zIndex="true">
                        <Icon :height="20" :width="20">
                            <IconChevronLeft />
                        </Icon>
                    </SmrTooltip>
                </div>  
            </transition>
            <transition name="fade">
                <div class="item-slider__navigation__arrow item-slider__navigation__arrow--next" v-show="!sliderIsEnd" @click="nextSliderHandler">
                    <SmrTooltip :content="tooltips.right ? tooltips.right.content : ''" :position="tooltips.right ? tooltips.right.position : ''" :zIndex="true">
                        <Icon :height="20" :width="20">
                            <IconChevronRight />
                        </Icon>
                    </SmrTooltip>    
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '@/components/Icon.vue'
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
import IconChevronLeft from '@/components/icons/IconChevronLeft.vue'
import SmrTooltip from'@/components/SmrTooltip.vue'
export default {
    props: {
        sliderClass: {
            type: String,
            default: ''
        },
        sliderOptions: {
            type: Object,
            default: () => {}
        },
        hideUIUntilInteraction: {
            type: Boolean,
            default: false
        },
        tooltips: {
            type: [Boolean, Object],
            default: false,
        }
    },
    components: {
        Icon,
        IconChevronRight,
        IconChevronLeft,
        SmrTooltip,
    },
    data() {
        return {
            sliderReady: false,
            sliderIsBeginning: true,
            sliderIsEnd: false,
            interacted: false,
            allSlidesAreShowing: false,
        }
    },
    updated() {
        this.areAllSlidesShowing()
    },
    computed: {
        ...mapGetters(['mobile']),
        slider() {
            return this.$refs.slider.$swiper
        },
        showNavigation() {
            if(this.mobile) {
                return false;
            } else if (this.allSlidesAreShowing) {
                return false
            } else if(this.hideUIUntilInteraction) {
                return this.sliderReady && this.interacted;
            } else {
                return this.sliderReady;
            }
        }
    },
    methods: {
        sliderReadyHandler() {
            this.sliderReady = true
            this.checkSliderEdgeStatus();
        },
        prevSliderHandler() {
            this.slideDir('left');
        },
        nextSliderHandler() {
            this.slideDir('right');
        },
        sliderReachBeginningHandler() {
            this.sliderIsBeginning = true;
        },
        sliderReachEndHandler() {
            this.sliderIsEnd = true;
        },
        sliderMoveStartHandler() {
            this.markInteracted();
        },
        checkSliderEdgeStatus() {
            this.sliderIsBeginning = this.slider.isBeginning
            this.sliderIsEnd = this.slider.isEnd
        },
        markInteracted() {
            if(this.slider.isLocked) return false;
            this.interacted = true;
            this.$emit('interacted');
        },
        slideDir(dir, smallAmount = false) {
            this.markInteracted();
            let currentTranslation = this.slider.translate;
            let sliderWidth = this.slider.$el[0].clientWidth;
            let delta = sliderWidth * (smallAmount ? 0.2 : 0.5);
            let multiplier = dir === 'right' ? -1 : 1;
            this.slider.translateTo(currentTranslation + multiplier * delta);
        },
        slideToPosition(position) {
            this.markInteracted();
            this.slider.translateTo(position, 0);
        },
        areAllSlidesShowing() {
            const swiperWidth = this.slider.width
            const slidesWidth = this.$refs.slider.$children.map(child => child.$el.offsetWidth).reduce((previous, current) => previous + current)
            this.allSlidesAreShowing = slidesWidth < swiperWidth
        },
        update() {
            this.slider.update()
        }
    }
}
</script>

<style lang="scss">
.item-slider {
    $block: &;
    &__slider {
        overflow: visible;
    }
    &__navigation {
        &__arrow {
            position: absolute;
            @include flex-center;
            top: 0;
            height: 100%;
            background: white;
            width: 40px;
            z-index: 1;
            color: $color-grey-dark;
            cursor: pointer;

            .no-touch &:hover {
                color: $color-black;
            }

            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                height: 100%;
                width: 20px;
            }

            &--prev {
                left: 0;
                &:before {
                    left: 100%;
                    background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
                }
            }
            &--next {
                right: 0;
                &:before {
                    right: 100%;
                    background: linear-gradient(270deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
                }
            }
        }
    }
}
</style>